import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import Chip from '@features/filter/Chip';

import { storeMyColleaguesSearchKey, toggleMyColleaguesFilter } from '@store/actions/MyColleaguesAction';
import { useMyColleagues } from '@store/reducers';

const FilterTopHeader = () => {
	const { isShowFilter, showDetailsPage } = useMyColleagues();
	const [showSearch, setShowSearch] = useState(false);
	const [searchInput, setSearchInput] = useState('');
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(storeMyColleaguesSearchKey(''));
		setSearchInput('');
	}, []);

	const searchRef = useRef();
	const debounceTimeout = useRef(null);

	const handleSearchChange = (e) => {
		const value = e.target.value;
		setSearchInput(value);
		if (debounceTimeout.current) {
			clearTimeout(debounceTimeout.current);
		}
		debounceTimeout.current = setTimeout(() => {
			dispatch(storeMyColleaguesSearchKey(value));
		}, 500);
	};

	const toggleFilter = () => {
		dispatch(toggleMyColleaguesFilter(!isShowFilter));
	};

	useEffect(() => {
		if (searchRef.current) {
			searchRef.current.focus();
		}
	}, [showSearch]);

	return (
		!showDetailsPage && (
			<div className="filter-container-top filter-container-top-v2" style={{ background: '#F7F8FA' }}>
				<div className="filters">
					<div className="filter-toggle" onClick={toggleFilter}>
						<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
						<span>Filter</span>
					</div>
					<Chip />
				</div>
				<div className="filter-actions collections-filter-actions">
					<div className="form-group size32 m-0 mr-3 search-filter filter-with-animation">
						<form
							className={`with-icon right-icon ${showSearch ? '' : 'hidden'}`}
							autoComplete="off"
							onSubmit={(e) => e.preventDefault()}
						>
							<input
								type="text"
								name="search"
								placeholder="Name or email"
								value={searchInput}
								onChange={handleSearchChange}
								ref={searchRef}
								autoComplete="off"
							/>
							<span
								className="right-icon"
								onClick={(e) => {
									e.stopPropagation();
									setShowSearch((prev) => !prev);
								}}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="23"
									height="22"
									viewBox="0 0 23 22"
									fill="none"
								>
									<path
										d="M10.543 16.5C14.3399 16.5 17.418 13.422 17.418 9.625C17.418 5.82804 14.3399 2.75 10.543 2.75C6.74601 2.75 3.66797 5.82804 3.66797 9.625C3.66797 13.422 6.74601 16.5 10.543 16.5Z"
										stroke="#21242B"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M19.2526 18.3346L15.5859 14.668"
										stroke="#21242B"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</span>
						</form>
					</div>
				</div>
			</div>
		)
	);
};

export default FilterTopHeader;
